var _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllustrationFeaturegateComponentsinline = function SvgIllustrationFeaturegateComponentsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 90,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m30 32 1.44.6-.385.923-1.44-.6a1 1 0 0 1 0-1.846l1.44-.6.385.923L30 32Zm3.36-1.4-.385-.923 2.88-1.2.385.923-2.88 1.2Zm4.8-2-.385-.923 2.88-1.2.385.923-2.88 1.2Zm4.8-2-.385-.923 2.88-1.2.385.923-2.88 1.2Zm4.8-2-.385-.923 2.88-1.2.385.923-2.88 1.2Zm9.6-1.2.385-.923 2.88 1.2-.385.923-2.88-1.2Zm4.8 2 .385-.923 2.88 1.2-.385.923-2.88-1.2Zm4.8 2 .385-.923 2.88 1.2-.385.923-2.88-1.2Zm4.8 2 .385-.923 2.88 1.2-.385.923-2.88-1.2Zm2.88 4 .385.923-2.88 1.2-.385-.923 2.88-1.2Zm-4.8 2 .385.923-2.88 1.2-.385-.923 2.88-1.2Zm-4.8 2 .385.923-2.88 1.2-.385-.923 2.88-1.2Zm-4.8 2 .385.923-2.88 1.2-.385-.923 2.88-1.2Zm-9.6 1.2-.385.923-2.88-1.2.385-.923 2.88 1.2Zm-4.8-2-.385.923-2.88-1.2.385-.923 2.88 1.2Zm-4.8-2-.385.923-2.88-1.2.385-.923 2.88 1.2Zm-4.8-2-.385.923-2.88-1.2.385-.923 2.88 1.2Zm16.32 6.8-.385.923 1.44.6a1 1 0 0 0 .77 0l1.44-.6-.385-.923L54 42l-1.44-.6Zm24-8.8.385.923 1.44-.6a1 1 0 0 0 0-1.846l-1.44-.6-.385.923L78 32l-1.44.6Zm-21.12-10 .385-.923-1.44-.6a1 1 0 0 0-.77 0l-1.44.6.385.923L54 22l1.44.6Z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m29.62 40.94 24.36 10.44 24.35-10.44L53.98 30.5 29.62 40.94Z",
    clipRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m29.62 49.94 24.36 10.44 24.35-10.44L53.98 39.5 29.62 49.94Z",
    clipRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m29.62 58.94 24.36 10.44 24.35-10.44L53.98 48.5 29.62 58.94Z",
    clipRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 50,
    height: 16,
    x: 29,
    y: 54,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29 54h50v16H29z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M39.399 55.01 30 58.948 54 69l24-10.052L68.562 55",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m30 58.948-.386-.923a1 1 0 0 0 0 1.845l.386-.922ZM54 69l-.386.922a1 1 0 0 0 .772 0L54 69Zm24-10.052.386.922a1 1 0 0 0 0-1.845l-.386.923Zm-38.987-4.86-9.4 3.937.773 1.845 9.4-3.938-.773-1.845Zm-9.4 5.782 24 10.052.773-1.844-24-10.053-.772 1.845Zm24.773 10.052 24-10.052-.772-1.845-24 10.053.772 1.844Zm24-11.897-9.439-3.948-.771 1.846 9.438 3.947.772-1.845Z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 50,
    height: 16,
    x: 29,
    y: 45,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29 45h50v16H29z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M39.399 46.01 30 49.948 54 60l24-10.052-8.568-3.584-.87-.364",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m30 49.948-.386-.923a1 1 0 0 0 0 1.845l.386-.922ZM54 60l-.386.922a1 1 0 0 0 .772 0L54 60Zm24-10.052.386.922a1 1 0 0 0 0-1.845l-.386.923Zm-8.568-3.584-.386.923.386-.923Zm-30.42-1.277-9.398 3.938.772 1.845 9.4-3.938-.773-1.845Zm-9.398 5.783 24 10.052.772-1.844-24-10.053-.772 1.845Zm24.772 10.052 24-10.052-.772-1.845-24 10.053.772 1.844Zm24-11.897-8.568-3.584-.772 1.846 8.568 3.583.772-1.845Zm-8.568-3.584-.87-.364-.772 1.846.87.364.772-1.846Z",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M29.808 40.538a.5.5 0 0 0 0 .924l24.005 10a.5.5 0 0 0 .384 0l23.995-10a.5.5 0 0 0 0-.924l-23.995-10a.5.5 0 0 0-.384 0l-24.005 10Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m92.404 65.075-.957 1.912a.5.5 0 0 1-.894 0l-.957-1.912a1.5 1.5 0 0 0-.67-.671l-1.913-.957a.5.5 0 0 1 0-.894l1.912-.957a1.5 1.5 0 0 0 .671-.67l.957-1.913a.5.5 0 0 1 .894 0l.957 1.913c.145.29.38.525.67.67l1.913.957a.5.5 0 0 1 0 .894l-1.912.957a1.5 1.5 0 0 0-.671.67Z",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m93.404 28.075-.957 1.913a.5.5 0 0 1-.894 0l-.957-1.913a1.5 1.5 0 0 0-.67-.671l-1.913-.957a.5.5 0 0 1 0-.894l1.912-.957a1.5 1.5 0 0 0 .671-.67l.957-1.913a.5.5 0 0 1 .894 0l.957 1.912c.145.29.38.526.67.671l1.913.957a.5.5 0 0 1 0 .894l-1.912.957a1.5 1.5 0 0 0-.671.67Zm10 12-1.957 3.912a.5.5 0 0 1-.894 0l-1.957-3.913a1.5 1.5 0 0 0-.67-.67l-3.913-1.957a.5.5 0 0 1 0-.894l3.912-1.957a1.5 1.5 0 0 0 .671-.67l1.957-3.914a.5.5 0 0 1 .894 0l1.957 3.913c.145.29.38.526.671.671l3.913 1.957a.5.5 0 0 1 0 .894l-3.913 1.957c-.291.145-.526.38-.671.67Zm-87 26-1.957 3.912a.5.5 0 0 1-.894 0l-1.957-3.912a1.5 1.5 0 0 0-.67-.671l-3.914-1.957a.5.5 0 0 1 0-.894l3.913-1.957a1.5 1.5 0 0 0 .671-.67l1.957-3.913a.5.5 0 0 1 .894 0l1.957 3.913c.145.29.38.525.67.67l3.913 1.957a.5.5 0 0 1 0 .894l-3.912 1.957a1.5 1.5 0 0 0-.671.67Z",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m17.404 26.075-.957 1.913a.5.5 0 0 1-.894 0l-.957-1.913a1.5 1.5 0 0 0-.67-.671l-1.914-.957a.5.5 0 0 1 0-.894l1.913-.957a1.5 1.5 0 0 0 .671-.67l.957-1.913a.5.5 0 0 1 .894 0l.957 1.912c.145.29.38.526.67.671l1.913.957a.5.5 0 0 1 0 .894l-1.912.957a1.5 1.5 0 0 0-.671.67Z",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m7.404 38.075-.957 1.912a.5.5 0 0 1-.894 0l-.957-1.913a1.5 1.5 0 0 0-.67-.67l-1.914-.957a.5.5 0 0 1 0-.894l1.913-.957a1.5 1.5 0 0 0 .671-.67l.957-1.913a.5.5 0 0 1 .894 0l.957 1.913c.145.29.38.525.67.67l1.914.957a.5.5 0 0 1 0 .894l-1.913.957a1.5 1.5 0 0 0-.671.67Z",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29 30h50v40H29z"
  })))));
};
export default SvgIllustrationFeaturegateComponentsinline;